export interface CampaignBannerConfig {
	id: string;
	isActive: boolean;
	campaignEndDate: string;
	timezone: string;
	url: string;
	title: string;
	description: string;
	overlayTitle: string;
	overlaySubtitle: string;
	backgroundImage: string;
	freeAdmissionImage: string;
	calligraphyImage: string;
	gtmEventName: string;
}

export const KANAGAWA_2026_CAMPAIGN: CampaignBannerConfig = {
	id: 'kanagawa-2026',
	isActive: true,
	campaignEndDate: '2026-03-15T18:00:00',
	timezone: 'America/New_York',
	url: 'https://www.peatix.com/us/discover/experience-kanagawa',
	title: 'Featured Event',
	description: 'Spend the weekend in Kanagawa without leaving Brooklyn. March 14-15 @ Japan Village',
	overlayTitle: 'A Japanese Art & Culture Experience',
	overlaySubtitle: 'Brought to you by Kanagawa Prefecture, Japan',
	backgroundImage: '@/assets/images/kanagawa-hero-bg.webp',
	freeAdmissionImage: '@/assets/images/free-admission.webp',
	calligraphyImage: '@/assets/svg/kanagawa-hero-title.svg',
	gtmEventName: 'experience-kanagawa',
};

export const ACTIVE_CAMPAIGN = KANAGAWA_2026_CAMPAIGN;
